import 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js'
export class PivotCarousel extends HTMLElement {
  constructor() {
    super()

    this.slides = [...this.querySelectorAll('.splide__slide')]

    this.attrs = this.__getAttributes()

    // Elementos
    this.slider = this.querySelector('.splide')
    this.list = this.querySelector('.splide__list')

    // Implantar los slides
    // this.slides.forEach(slide => {
    //   const item = document.createElement('li')
    //   item.classList.add('splide__slide')
    //   item.appendChild(slide)
    //   this.list.appendChild(item)
    // })

    // Remover el contenedor inicial de slides
    this.querySelector('.pivot--carousel')?.remove()
  }
  connectedCallback() {
    if (!this.isConnected) return
    this.splide = new Splide(this.slider, {
      perPage: Number(this.attrs['desktop-columns'] || 1),
      pagination: this.attrs['desktop-pagination'] !== undefined,
      arrows: this.attrs['desktop-arrows'] !== undefined,
      autoplay: this.attrs['desktop-autoplay'] !== undefined,
      interval: Number(this.attrs['desktop-duration'] || 5000),
      gap:
        this.slides.length > 1
          ? 'var(--grid-desktop-horizontal-spacing)'
          : '0px',
      trimSpace: true,
      type:
        this.attrs['transition'] !== 'fade' &&
        this.attrs['desktop-loop'] !== undefined
          ? 'loop'
          : this.attrs['transition'],
      rewind:
        this.attrs['transition'] === 'fade' &&
        this.attrs['desktop-loop'] !== undefined,
      drag: this.attrs['drag'] !== undefined,
      breakpoints: {
        750: {
          perPage: Number(this.attrs['mobile-columns'] || 1),
          pagination: this.attrs['mobile-pagination'] !== undefined,
          arrows: this.attrs['mobile-arrows'] !== undefined,
          autoplay: this.attrs['mobile-autoplay'] !== undefined,
          interval: Number(this.attrs['mobile-duration'] || 5000),
          type:
            this.attrs['transition'] !== 'fade' &&
            this.attrs['mobile-loop'] !== undefined
              ? 'loop'
              : this.attrs['transition'],
          rewind:
            this.attrs['transition'] === 'fade' &&
            this.attrs['mobile-loop'] !== undefined,
        },
      },
    })
    this.splide.mount()
    console.log(this.splide)
  }
  __getAttributes() {
    return this.getAttributeNames().reduce(
      (obj, name) => ({
        ...obj,
        [name]: this.getAttribute(name),
      }),
      {}
    )
  }
}
if (!customElements.get('pivot-carousel')) {
  customElements.define('pivot-carousel', PivotCarousel)
}

class PivotCarouselControls extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    if (!this.isConnected) return
    // Custom Arrows
    const nextArrow = this.querySelector(`.pivot-carousel__arrow--next`)
    const prevArrow = this.querySelector(`.pivot-carousel__arrow--prev`)
    const parent = this.closest('pivot-carousel, [pivot-carousel]')

    if (nextArrow)
      nextArrow.addEventListener('click', e => {
        parent?.splide?.Components.Controller.go('>')
      })
    if (nextArrow)
      prevArrow.addEventListener('click', e => {
        parent?.splide?.Components.Controller.go('<')
      })
  }
}
if (!customElements.get('pivot-carousel-controls')) {
  customElements.define('pivot-carousel-controls', PivotCarouselControls)
}

